




































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MetricPoints from "@/api/metricPoints";
import {InternationalizedField} from "@/api/common";

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldMetricPoints extends CommonVue {
    @Model('update') public metric_points_list!: MetricPoints[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type:Array}) public metricNames: InternationalizedField<string>[];

    public metric_points: MetricPoints = null;
    public isNewWord: boolean = false;
    public showModal: boolean = false;
    public metricOptions: object[] = null;

    // noinspection JSMethodCanBeStatic
    public edit(point: MetricPoints) {
        this.metric_points = point;
        this.isNewWord = false;
        this.showModal = true;
        this.loadMetricOptions();
    }

    public newMetricPoints() {
        this.metric_points = new MetricPoints();
        this.isNewWord = true;
        this.showModal = true;
        this.loadMetricOptions();
    }

    public saveClicked() {
        if (!this.metric_points) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            this.metric_points.index = this.metricNames.findIndex(x => x.en === this.metric_points.name);
            if (this.isNewWord) {
                this.metric_points_list.push(this.metric_points);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save metric points', e);
        }
    }

    public loadMetricOptions() {
        this.metricOptions = [];
        for (const option of this.metricNames.filter(e => {
            return !this.metric_points_list.some(item => item.name === e.en);
        })) {
            this.metricOptions.push({ key: option.en, value: option.en, text: option.en });
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.metric_points.name || !this.metric_points.points) {
            throw Error('Please insert the metric and points.');
        }
    }

    public deleteClicked() {
        const newList = this.metric_points_list.filter((value) => {
            return value !== this.metric_points;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }

    public updateMetricName(metric: MetricPoints, metric_index: number) {
        if (this.metric_points_list[metric_index] && this.metricNames[metric.index])
            this.metric_points_list[metric_index].name = this.metricNames[metric.index].en;
        return this.metric_points_list[metric_index].name;
    }
}

